import { render, staticRenderFns } from "./ColorProperties.vue?vue&type=template&id=c1116920&scoped=true"
import script from "./ColorProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorProperties.vue?vue&type=style&index=0&id=c1116920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1116920",
  null
  
)

export default component.exports